import { render, staticRenderFns } from "./GoodsResultCard.vue?vue&type=template&id=55d51a6e&scoped=true"
import script from "./GoodsResultCard.vue?vue&type=script&lang=ts"
export * from "./GoodsResultCard.vue?vue&type=script&lang=ts"
import style0 from "./GoodsResultCard.vue?vue&type=style&index=0&id=55d51a6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d51a6e",
  null
  
)

export default component.exports